// Archivo: app/[locale]/educacion/page.jsx
'use client';
import { use } from 'react';
import { useTranslations } from 'next-intl';
import Link from 'next/link';

export default function EducationPage({ params: paramsPromise }) {
  const { locale } = use(paramsPromise);
  const t = useTranslations('Educacion');
  
  return (
    <div className="min-h-screen bg-slate-50 py-12 px-4">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-12">
          <h1 className="text-3xl font-bold text-slate-900">{t('pageTitle')}</h1>
          <p className="text-slate-500 mt-2">{t('pageSubtitle')}</p>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {/* Tarjeta 1 */}
          <Link href={`/${locale}/educacion/metabolismo`} className="block group">
            <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden hover:shadow-md transition">
              <div className="h-48 bg-blue-100 flex items-center justify-center text-6xl">🧬</div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-slate-900 group-hover:text-blue-600 transition">{t('metabolicHealthTitle')}</h3>
                <p className="text-slate-500 mt-2">{t('metabolicHealthDesc')}</p>
              </div>
            </div>
          </Link>

          {/* Tarjeta 2 (Placeholder) */}
          <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden opacity-75">
            <div className="h-48 bg-slate-100 flex items-center justify-center text-6xl">🧠</div>
            <div className="p-6">
              <h3 className="text-xl font-bold text-slate-900">{t('mentalHealthTitle')}</h3>
              <p className="text-slate-500 mt-2">{t('mentalHealthDesc')}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}



